if (!customElements.get('quick-shop')) {
  class Quickshop extends HTMLElement {
    constructor() {
      super();

      this.parentCard = this.closest('[data-product-card]');
      this.popupIsOpenClass = 'quickshop--is-open';

      this.bindEvents();
    }

    /**
     * Bind necessary event listeners
     */
    bindEvents() {
      // Bind popup toggle events
      this.parentCard.querySelectorAll('[data-quickshop-toggle]').forEach((button) =>
        button.addEventListener('click', this.onPopupToggle.bind(this))
      );

      // Bind option select events
      this.querySelectorAll('[data-quickshop-option]').forEach((option) =>
        option.addEventListener('click', this.onOptionSelect.bind(this, option.value, option.dataset.inventoryQuantity))
      );

      // Bind color grouped products select events (only for upsell cards [for now])
      if (this.closest('[data-cart-drawer-upsell]')) {
        this.querySelectorAll('[data-product-color-selector]').forEach((swatch) => {
          swatch.addEventListener('click', this.onColorGroupSelect.bind(this));
        });
      }
    }

    /**
     * Toggles the options popup while closing all others
     */
    onPopupToggle(event) {
      event.preventDefault();

      const upsellSwiperComponent = this.closest('[data-cart-drawer-upsell-swiper]');
      // If we are  clicking on a product card in the mobile swiper, we change the currentQuickshop to the non mobile card (outside of the swiper)
      const currentQuickshop = upsellSwiperComponent ? document.querySelector(`[data-cart-drawer-upsell-desktop] [data-quickshop-product-handle="${this.dataset?.quickshopProductHandle}"]`) : this;
      const allQuickshops = document.querySelectorAll('quick-shop');

      allQuickshops.forEach((quickshop) => {
        if (quickshop !== currentQuickshop) {
          quickshop.close();
        }
      });

      if (currentQuickshop.classList.contains(this.popupIsOpenClass)) {
        currentQuickshop.close();
      } else {
        currentQuickshop.open();
      }
    }

    open() {
      this.classList.add(this.popupIsOpenClass);
    }

    close() {
      this.classList.remove(this.popupIsOpenClass);
    }

    /**
     * Selects a product variant
     * @description Selects the clicked option/variant to be added to the cart leveraging the product form component.
     * @param {String} variantId
     * @param {String} inventoryQuantity 
     */
    onOptionSelect(variantId, inventoryQuantity) {
      const selectedOptionClass = 'options__label--checked';
      const productForm = this.querySelector('product-form');
      const hiddenId = productForm.querySelector('input[name="id"]');
      const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');

      hiddenId.value = variantId;
      hiddenInventoryQty.value = inventoryQuantity;
      
      this.querySelectorAll('[data-quickshop-option]').forEach((option) => {
        if (option.value === variantId) {
          option.nextElementSibling?.classList.add(selectedOptionClass);
        } else {
          option.nextElementSibling?.classList.remove(selectedOptionClass);
        }
      });
    }

    /**
     * Selects a color grouped product
     * @description Selects the color grouped product to be added to the cart by refreshing the quickshop form.
     * @param {String} variantId
     * @param {String} inventoryQuantity 
     */
    onColorGroupSelect(event) {
      event.preventDefault();
      event.stopPropagation();

      const target = event.currentTarget;
      const newHandle = target.dataset.productColorSelector;
      const oldHandle = this.closest('[data-product-card]').dataset.productCard;

      const sourceTargetSelector = `[data-product-card="${newHandle}"]`;
      const destinationTargetSelector = `[data-product-card="${oldHandle}"]`;

      fetch(`${target.href}?view=card-upsell`)
      .then(response => response.text())
      .then(html => {
        const returnedHtml = new DOMParser().parseFromString(html, 'text/html');
        const sourceElem = returnedHtml.querySelector(sourceTargetSelector);
        
        const allTargetElems = this.closest('[data-cart-drawer-upsell]').querySelectorAll(destinationTargetSelector);

        allTargetElems.forEach((elem) => {
          elem.innerHTML = sourceElem.innerHTML;
          elem.dataset.productCard = newHandle;

          // Open only the desktop upsell card
          if (elem.closest('[data-cart-drawer-upsell-desktop]')) {
            elem.querySelector('quick-shop').open();
          }
        });
      })
      .catch(error => {
        console.error('Error while fetching product quickshop template:', error);
      });
    }
  }

  window.Quickshop = Quickshop;
  customElements.define('quick-shop', Quickshop);
}

